import { render, staticRenderFns } from "./TheErrorPage.vue?vue&type=template&id=1d60f00a&"
import script from "./TheErrorPage.vue?vue&type=script&lang=js&"
export * from "./TheErrorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports